import { getCookie } from '../cookie.js'
export const gobroadMainNav = [
  {
    url: 'http://liuxue.xdf.cn/index3.shtml',
    title: '留学申请'
  },
  {
    url: 'http://goabroad.xdf.cn',
    title: '备考辅导'
  },
  {
    url: 'http://youxue.xdf.cn/',
    title: '国际游学'
  },
  // {
  //   url: `http://souke.xdf.cn/Teacher/${getCookie('soukecityid')}.html`,
  //   title: '教师'
  // },
  {
    url: `http://souke.xdf.cn/Maps/${getCookie('soukecityid')}.html`,
    title: '校区'
  },
  {
    url: `https://tpo.xdf.cn/index.shtml`,
    title: '托福机考练习'
  },
  {
    url: `https://ieltscat.xdf.cn/`,
    title: '雅思机考练习'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/gobroad/mainnav.js